const RuleOnSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28.001" height="26.415">
      <g data-name="グループ 17" strokeMiterlimit="10">
        <path data-name="Icon awesome-stamp" d="M28 25.665H0" fill="none" stroke="#000" strokeWidth="1.5" />
        <g data-name="グループ 16">
          <g data-name="パス 55" fill="none">
            <path d="M17.501 13.891v-2.019a9.288 9.288 0 011.173-4.25 5.174 5.174 0 00.495-3.3 5.249 5.249 0 00-6.1-4.238 5.248 5.248 0 00-4.321 5.165 5.142 5.142 0 00.474 2.165 19.606 19.606 0 011.276 6.473 1.61 1.61 0 01-1.607 1.614h10.216a1.609 1.609 0 01-1.606-1.61z" />
            <path
              d="M16.003 14.001a3.3 3.3 0 01-.002-.11v-2.063c.051-1.714.518-3.412 1.35-4.913a3.696 3.696 0 00.342-2.328 3.743 3.743 0 00-4.356-3.027 3.747 3.747 0 00-3.086 3.693 3.664 3.664 0 00.327 1.512c.923 1.85 1.362 5.313 1.422 7.071l.001.048c0 .039 0 .078-.002.117h4.004m3.107 1.5H8.894a1.61 1.61 0 001.607-1.614c-.059-1.73-.494-4.929-1.276-6.473a5.142 5.142 0 01-.474-2.165A5.248 5.248 0 0113.072.084a5.249 5.249 0 016.097 4.238 5.174 5.174 0 01-.495 3.3 9.288 9.288 0 00-1.173 4.25v2.019c0 .89.72 1.61 1.609 1.61z"
              fill="#000"
            />
          </g>
          <g data-name="パス 56" className="main-fill">
            <path d="M26.251 22h-24.5c-.551 0-1-.45-1-1v-1.75c0-2.482 2.019-4.5 4.5-4.5h17.5c2.481 0 4.5 2.018 4.5 4.5V21c0 .55-.449 1-1 1z" />
            <path
              d="M5.251 15.5a3.754 3.754 0 00-3.75 3.75V21c0 .137.112.25.25.25h24.5a.25.25 0 00.25-.25v-1.75a3.754 3.754 0 00-3.75-3.75h-17.5m0-1.5h17.5a5.25 5.25 0 015.25 5.25V21a1.75 1.75 0 01-1.75 1.75h-24.5A1.75 1.75 0 01.001 21v-1.75c0-2.901 2.35-5.25 5.25-5.25z"
              fill="#000"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default RuleOnSvg
